import { IActivity } from "./activity.interface";
import { ICustomer } from "./customer.interface";
import { TGeo } from "./globals";
import { DirPath, IDrive } from "./project-register.interface";

export enum ProjectStatus {
  ONGOING = "ONGOING",
  COMPLETED = "COMPLETED",
  ARCHIVE = "ARCHIVE",
}
export interface IProjectAddress extends TGeo {
  radius?: number;
  postalCode?: string;
}
export interface RecyclingPercentage {
  recyclingPercentage: number;
  nonRecyclingPercentage: number;
}
export interface IProjectInduction {
  id: string;
  name: string;
  value: string;
  projectId?: string;
}
export interface ReportSummary {
  recyclingPercentage: RecyclingPercentage;
}

export interface Address {
  label: string;
  radius: number;
  latitude: string;
  longitude: string;
  areaLocation: string;
}

export interface IProject {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  status: ProjectStatus;
  startDate: string;
  endDate: string;
  address: Address;
  radius: number;
  customerProjectReference: string;
  ourReferenceNumber: string;
  budgetHours: number | null;
  customerId: string;
  userAccessListId?: null | string;
  customer: ICustomer;
  customerProjectTeam: {
    id: string;
    role: string;
    employmentType: string;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    image: string | null;
  }[];
  ourProjectTeam: {
    id: string;
    firstName: string;
    middleName: string;
    lastName: string;
  }[];
  projectInductions: IProjectInduction[];
  reportSummary: ReportSummary | null;
  isGreenStarProject: boolean;
  projectProgress: number | null;
  usedWorkHours: number;
  lastActivityDate: string;
  activity: IActivity[];
}

export interface AddressOrBasicInfoOrWorkInfoOrDeclaration {
  id: string;
}
export interface Permissions {
  customerPortal: boolean;
  projectFinance: boolean;
  emailNotification: boolean;
}
export interface User {
  id: string;
  createdAt: string;
  updatedAt: string;
  email: string;
  phoneNumber: string;
  status: string;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  address: string;
  image?: null;
  otpHash?: null;
  deviceId?: null;
  permissions?: null[] | null;
  role: string;
  employmentType: string;
}

export interface PermissionsEntity {
  action: string;
  resource: string;
  workspace: string;
}
export interface GeneralManagersEntityOrProjectManagersEntityOrSiteManagersEntityOrContractAdminstratorsEntityOrAdminStaffsEntity {
  id: string;
  createdAt: string;
  updatedAt: string;
  email: string;
  phoneNumber: string;
  status: string;
  firstName: string;
  middleName: string;
  lastName: string;
  address: string;
  image?: null;
  otpHash?: null;
  deviceId?: null;
  permissions?: PermissionsEntity[] | null;
  role: string;
  employmentType: string;
}

export interface TeamMembersEntity {
  id: string;
  workspaceId: string;
  userId: string;
  onboardingStatus: string;
  approvedStatus: string;
  basicInfo: AddressOrBasicInfoOrWorkInfoOrDeclaration;
  workInfo: AddressOrBasicInfoOrWorkInfoOrDeclaration;
  declaration: AddressOrBasicInfoOrWorkInfoOrDeclaration;
  projectId: string;
  user: User;
}

export interface BatchFileItem {
  file: File;
  path: string[];
  status: "pending" | "uploading" | "success" | "error";
  progress: number;
  error?: string;
}

export interface BatchFolderItem {
  name: string;
  path: string[];
  children?: BatchFolderItem[];
  documents?: BatchFileItem[];
}

export interface BatchDirectoryStructure {
  directories: BatchFolderItem[];
  files?: {
    // For mapping to files in the response
    name: string;
    size: number;
    path: string[]; // To generate filePaths
  }[];
}

export interface ExtendedDriveResponse extends GeneralResponse<IDrive[]> {
  dirId: string | null;
  directoryPath: DirPath[];
}
